import { createFileRoute } from '@tanstack/react-router';

import { buildBreadcrumbSchema, buildSeoHead, buildWebPageSchema, jsonLdScript, ROUTE_META } from '@src/corelib/seo';

export const Route = createFileRoute('/compare/sailpoint')({
  head: () => ({
    ...buildSeoHead({ path: '/compare/sailpoint', ...ROUTE_META['/compare/sailpoint'] }),
    scripts: [
      jsonLdScript(buildBreadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Compare', path: '/compare' }, { name: 'SailPoint', path: '/compare/sailpoint' }])),
      jsonLdScript(buildWebPageSchema({ path: '/compare/sailpoint', ...ROUTE_META['/compare/sailpoint'] })),
    ],
  }),
});
